import { Result, failure, success } from '../shared'
import { LoanOfficerProvider } from './loanOfficer.provider'
import {
  LoanOfficerServiceErrorCode,
  LoanOfficerFailure,
  LoanOfficersServerData,
  AppOfficersServerData,
} from './loanOfficer.types'

export class LoanOfficerService {
  constructor(private provider: LoanOfficerProvider) {}

  public async getOfficerList(active: boolean): Promise<Result<LoanOfficersServerData, LoanOfficerFailure>> {
    try {
      const { data } = await this.provider.officerList(active)
      return success(data)
    } catch (error) {
      return failure(LoanOfficerServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getAppList(active: boolean): Promise<Result<AppOfficersServerData, LoanOfficerFailure>> {
    try {
      const { data } = await this.provider.appList(active)
      return success(data)
    } catch (error) {
      return failure(LoanOfficerServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getAvailableList(
    loanId: number,
    loanHash: string,
  ): Promise<Result<LoanOfficersServerData, LoanOfficerFailure>> {
    try {
      const { data } = await this.provider.availableList(loanId, loanHash)
      return success(data)
    } catch (error) {
      return failure(LoanOfficerServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
